// extracted by mini-css-extract-plugin
module.exports = {"container":"_2A1WDtrLqYu67SAie1R8ep","cancelBtn":"_14YzTk-tNCUL-mjU98Vvrf","icon":"_20-9YgQrFzmu9-17FPjhHo","saveBtn":"_3EJ23L2YeURzQ0bQKGvK8i"};